module.exports = __webpack_public_path__ + "img/b1-1.37a3a22.png";